import { Granularity, TimeRangeOption } from '../../types';

export function getGranularity(timeRange?: TimeRangeOption) {
  return timeRange === TimeRangeOption.THREE_DAY
    ? Granularity.HOURLY
    : timeRange === TimeRangeOption.THREE_MONTH
      ? Granularity.MONTHLY
      : Granularity.DAILY;
}
